import { PureQueryOptions, ApolloClient } from 'apollo-client';
import { GET_ADVERTISER_DATA_QUERY } from '../../../containers/ThomasAdvertiserCampaignsContainer';
import { OPTIMIZE_CAMPAIGN_MUTATION } from '../../../containers/ThomasCampaignContainer';
import { GET_CAMPAIGN_EDIT_DATA } from '../../../containers/CampaignEditContainer';

export function refetchAdvertiserPageQueries(tgrams_id: string, campaign_id) {
  const refetchThomasCampaignPage = {
    query: GET_ADVERTISER_DATA_QUERY,
    variables: { tgrams_id }
  } as PureQueryOptions;
  const refetchThomasCampaignEdit = {
    query: GET_CAMPAIGN_EDIT_DATA,
    variables: { tgramsId: tgrams_id, campaignId:campaign_id }
  } as PureQueryOptions;

  return [refetchThomasCampaignPage, refetchThomasCampaignEdit];
}

const optimizeP3Campaign = async (
  client: ApolloClient<any>,
  campaignId: string,
  startDate: string,
  name: string,
  refetchQueries: any[],
  postMutateFunc?: () => any
) => {
  const response = await client.mutate({
    mutation: OPTIMIZE_CAMPAIGN_MUTATION,
    variables: { campaignId, startDate, name },
    refetchQueries
  });

  if (typeof postMutateFunc === 'function') {
    postMutateFunc();
  }

  return response;
};

export { optimizeP3Campaign };
